import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IOrder, IOrderCancelInput, IOrderInput, IOrderPdf } from "@/interfaces/order.interfaces";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class OrderService {
  private baseUrl = "api/v1/order";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IOrder>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const orders = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return orders;
  }

  async filter(
    filter: IFilter<IOrder>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IOrder>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: IOrderInput): Promise<IOrder> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async getById(orderId: string): Promise<IOrder> {
    const order = await httpRequest.get(`${this.baseUrl}/${orderId}`);

    return order;
  }

  async getPdf(orderId: string): Promise<IOrderPdf> {
    const pdf = await httpRequest.get<IOrderPdf>(`${this.baseUrl}/${orderId}/pdf`);
    if (!pdf?.base64) {
      throw new Error("Order PDF is empty.");
    }

    return pdf;
  }

  async update(formData: IOrderInput, orderId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${orderId}`, formData);
  }

  async cancel(input: IOrderCancelInput): Promise<void> {
    return await httpRequest.post(`${this.baseUrl}/cancelled`, input);
  }

  async deletePayment(orderId: number, paymentId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${orderId}/payment/${paymentId}`);
  }

  async deleteItem(orderId: number, itemId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${orderId}/item/${itemId}`);
  }
}

const orderService = new OrderService();
export default orderService;
